import { TweenMax, Power3 } from 'gsap';

import Nav from './nav';

class Sidebar extends Nav {
  constructor() {
    super();

    this.dom.items = this.dom.lists[0].querySelectorAll('.js-item');

    this.state.expand = false;
    this.state.isInitialized = false;

    this.data = {
      total: this.dom.items.length,
      padding: 60,
      closed: null,
      open: null
    };
  }

  toggle = () => {
    if (this.state.isAnimating) return;

    this.state.isAnimating = true;

    const items = [].slice.call(this.dom.items, 2);

    const tweenList = TweenMax.fromTo(
      this.dom.lists[0],
      0.6,
      { height: this.data.heightClosed },
      { height: this.data.heightOpen, ease: Power3.easeInOut }
    );

    if (!this.state.expand) {
      tweenList.play();

      TweenMax.staggerFromTo(
        items,
        0.15,
        { autoAlpha: 0 },
        { autoAlpha: 1, delay: 0.2 },
        0.05
      );
    } else {
      tweenList.reverse(0);

      TweenMax.staggerFromTo(
        items,
        0.15,
        { autoAlpha: 1 },
        { autoAlpha: 0 },
        -0.05
      );
    }

    this.state.expand = !this.state.expand;
    setTimeout(() => this.state.isAnimating = false, 600);
  }

  setData = () => {
    this.data.heightClosed = this.dom.items[1].offsetTop
      + this.dom.items[1].offsetHeight;

    this.data.heightOpen = this.dom.items[this.data.total - 1].offsetTop
      + this.dom.items[this.data.total - 1].offsetHeight;
  }

  setStyles = () => {
    TweenMax.to(
      this.dom.lists[0],
      0.4,
      { height: this.data.heightClosed, ease: Power3.easeInOut, delay: 0.5 },
    );
  }

  resize = () => {
    this.resizeHandler();

    if (!this.state.isMobile && !this.state.isInitialized) this.initNav();
    if (this.state.isMobile && this.state.isInitialized) this.destroyNav();
  }

  initNav = () => {
    this.setData();
    this.setStyles();

    window.addEventListener('resize', this.resize, { passive: true });
    this.dom.lists[0].addEventListener('mouseenter', this.toggle, { passive: true });
    this.dom.lists[0].addEventListener('mouseleave', this.toggle, { passive: true });

    this.state.isInitialized = true;
  }

  destroyNav = () => {
    this.dom.lists[0].removeEventListener('mouseenter', this.toggle);
    this.dom.lists[0].removeEventListener('mouseleave', this.toggle);

    this.state.isInitialized = false;
  }
}

export default Sidebar;
